"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Field = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Field — a labelled form control. The label sits ABOVE the control at
 * --font-size-sm / --color-text-secondary (surface-identity-and-shell.md §6.4),
 * not inline beside it.
 *
 *   <Field label="Survey"><Select …/></Field>
 */
const Field = ({
  label,
  htmlFor,
  hint,
  children,
  className = '',
  ...rest
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
  className: `field ${className}`.trim(),
  ...rest,
  children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
    className: "field__label",
    htmlFor: htmlFor,
    children: label
  }), children, hint && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "field__hint",
    children: hint
  })]
});

/**
 * Select — the product's dropdown, styled to design-system.json `dropdown`.
 *
 * This wraps the native <select> deliberately. The design system specifies the
 * dropdown's *surface* (white, 1px --color-border-medium, 4px radius) and its
 * item states; a native select renders its own option list, which the browser
 * styles and which cannot be themed consistently across platforms. The trade is
 * intentional: native keyboard handling, type-ahead, screen-reader semantics and
 * mobile pickers all come for free, and a hand-rolled listbox would have to
 * re-earn every one of them. The closed control matches the spec exactly; the
 * open list is the platform's.
 *
 *   <Select value={id} onChange={…}>
 *     <option value="">— Select a survey —</option>
 *   </Select>
 */
exports.Field = Field;
const Select = ({
  className = '',
  invalid = false,
  ...rest
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("select", {
  className: `select${invalid ? ' select--invalid' : ''} ${className}`.trim(),
  ...rest
});
var _default = exports.default = Select;